import Icon from '@mdi/react';
import { mdiLogout } from '@mdi/js';
import useGetGlobalSiteSettings from '@shared/features/global-site-settings/hooks/useGetGlobalSiteSettings.ts';
import { Link, useSearch } from '@tanstack/react-router';

interface ISessionExpiredProps {}

const SessionExpired = ({}: ISessionExpiredProps) => {
    const { loginUrl } = useGetGlobalSiteSettings();
    const { returnUrl } = useSearch({ strict: false });
    return (
        <div
            className='modal modal-system-message'
            id='modal-session-timeout'
            tabIndex={-1}
            role='dialog'
            aria-labelledby='sessionTimeout'
            aria-hidden='true'
            data-focus='false'
            style={{ display: 'block' }}
        >
            <div className='content'>
                <div
                    className='alert alert-info m-3 py-5 px-4 px-sm-5'
                    style={{ maxWidth: '25rem' }}
                    role='alert'
                >
                    <h5 className='alert-heading mb-3'>
                        <Icon
                            path={mdiLogout}
                            className='mdi mr-1'
                        />
                        Du har blivit utloggad
                    </h5>
                    <p>Av säkerhetsskäl blir du automatiskt utloggad efter 60 minuter.</p>
                    <Link
                        to={loginUrl + (returnUrl ? `?returnUrl=${returnUrl}` : '')}
                        className='btn btn-primary'
                    >
                        Logga in igen
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default SessionExpired;
